module.exports = __webpack_public_path__ + "static/media/100k.ffaf1ff4.jpg";